/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/user_properties.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DeviceCategory_DeviceCategoryValue } from "./common_enums";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.UserProperties
 */
export interface UserProperties {
    /**
     * @generated from protobuf field: optional string anonymous_id = 1;
     */
    anonymous_id?: string;
    /**
     * @generated from protobuf field: optional int32 favorites_channels_count = 2;
     */
    favorites_channels_count?: number;
    /**
     * @generated from protobuf field: optional int32 follow_series_count = 3;
     */
    follow_series_count?: number;
    /**
     * @generated from protobuf field: optional int32 follow_teams_count = 4;
     */
    follow_teams_count?: number;
    /**
     * @generated from protobuf field: optional string home_country_code = 5;
     */
    home_country_code?: string;
    /**
     * @generated from protobuf field: optional string home_dma = 6;
     */
    home_dma?: string;
    /**
     * @generated from protobuf field: optional string home_zip_code = 7;
     */
    home_zip_code?: string;
    /**
     * @generated from protobuf field: optional bool internal_user = 8;
     */
    internal_user?: boolean;
    /**
     * @generated from protobuf field: optional string language = 9;
     */
    language?: string;
    /**
     * @generated from protobuf field: optional string market = 10;
     */
    market?: string;
    /**
     * @generated from protobuf field: optional int32 my_stuff_movies_count = 11;
     */
    my_stuff_movies_count?: number;
    /**
     * @generated from protobuf field: optional int32 my_stuff_series_count = 12;
     */
    my_stuff_series_count?: number;
    /**
     * check type
     *
     * @generated from protobuf field: repeated string products = 13;
     */
    products: string[];
    /**
     * @generated from protobuf field: optional int32 profile_count = 14;
     */
    profile_count?: number;
    /**
     * @generated from protobuf field: optional string profile_id = 15;
     */
    profile_id?: string;
    /**
     * @generated from protobuf field: optional double record_hours_allowed = 16;
     */
    record_hours_allowed?: number;
    /**
     * @generated from protobuf field: optional double record_hours_used = 17;
     */
    record_hours_used?: number;
    /**
     * @generated from protobuf field: optional string segment_datamkt = 18;
     */
    segment_datamkt?: string;
    /**
     * TODO: checking type in the future
     *
     * @generated from protobuf field: optional string segment_rfm28 = 19;
     */
    segment_rfm28?: string;
    /**
     * @generated from protobuf field: map<string, string> subscription_add_ons_billing_status = 20;
     */
    subscription_add_ons_billing_status: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: map<string, string> subscription_add_ons_state = 21;
     */
    subscription_add_ons_state: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: map<string, string> subscription_add_ons_trial = 22;
     */
    subscription_add_ons_trial: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: map<string, string> subscription_base_billing_status = 23;
     */
    subscription_base_billing_status: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: map<string, string> subscription_base_state = 24;
     */
    subscription_base_state: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: map<string, string> subscription_base_trial = 25;
     */
    subscription_base_trial: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: optional string subscription_date = 26;
     */
    subscription_date?: string;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue subscription_device_category = 27;
     */
    subscription_device_category?: DeviceCategory_DeviceCategoryValue;
    /**
     * TODO: consider use enum in the future
     *
     * @generated from protobuf field: optional string subscription_os = 28;
     */
    subscription_os?: string;
    /**
     * @generated from protobuf field: optional string subscription_referrer = 29;
     */
    subscription_referrer?: string;
    /**
     * @generated from protobuf field: optional string subscription_utm_medium = 30;
     */
    subscription_utm_medium?: string;
    /**
     * @generated from protobuf field: optional string subscription_utm_source = 31;
     */
    subscription_utm_source?: string;
    /**
     * @generated from protobuf field: optional string user_id = 32;
     */
    user_id?: string;
    /**
     * @generated from protobuf field: optional string hashed_email = 33;
     */
    hashed_email?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class UserProperties$Type extends MessageType<UserProperties> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.UserProperties", [
            { no: 1, name: "anonymous_id", kind: "scalar", localName: "anonymous_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "87994684-d4d2-11ed-afa1-0242ac120002", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ID to follow not logged in users - Unauthenticated/Growth Events." } },
            { no: 2, name: "favorites_channels_count", kind: "scalar", localName: "favorites_channels_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of channels in favorite - Favorite Event." } },
            { no: 3, name: "follow_series_count", kind: "scalar", localName: "follow_series_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of series followed - ." } },
            { no: 4, name: "follow_teams_count", kind: "scalar", localName: "follow_teams_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of teams followed." } },
            { no: 5, name: "home_country_code", kind: "scalar", localName: "home_country_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ISO 3166-1 alpha-3 codes for countries." } },
            { no: 6, name: "home_dma", kind: "scalar", localName: "home_dma", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "DMA. - Subscription Events" } },
            { no: 7, name: "home_zip_code", kind: "scalar", localName: "home_zip_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "10001", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Zip. - Subscription Events" } },
            { no: 8, name: "internal_user", kind: "scalar", localName: "internal_user", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "false", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "If user is internal. - Subscription Events" } },
            { no: 9, name: "language", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "EN", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Language, check if we can select the language." } },
            { no: 10, name: "market", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ISO 3166-1 alpha-3 codes for countries." } },
            { no: 11, name: "my_stuff_movies_count", kind: "scalar", localName: "my_stuff_movies_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of movies in my stuff." } },
            { no: 12, name: "my_stuff_series_count", kind: "scalar", localName: "my_stuff_series_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of series in my stuff." } },
            { no: 13, name: "products", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "fubotv-basic", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "List of the user's products - Subscription Events." } },
            { no: 14, name: "profile_count", kind: "scalar", localName: "profile_count", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of profiles by user." } },
            { no: 15, name: "profile_id", kind: "scalar", localName: "profile_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1a5011d8-d4d3-11ed-afa1-0242ac120002", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Profile ID. - All Events" } },
            { no: 16, name: "record_hours_allowed", kind: "scalar", localName: "record_hours_allowed", opt: true, T: 1 /*ScalarType.DOUBLE*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1000.0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Total DVR space allowed to the user." } },
            { no: 17, name: "record_hours_used", kind: "scalar", localName: "record_hours_used", opt: true, T: 1 /*ScalarType.DOUBLE*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "234.8", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "DVR space used by the user." } },
            { no: 18, name: "segment_datamkt", kind: "scalar", localName: "segment_datamkt", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Provides information on the fact that a user is interested in content categories (sport, news, etc.)." } },
            { no: 19, name: "segment_rfm28", kind: "scalar", localName: "segment_rfm28", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "RFM 28 segmentation." } },
            { no: 20, name: "subscription_add_ons_billing_status", kind: "map", localName: "subscription_add_ons_billing_status", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Cloud DVR 1000\": \"Status\",\"Family Share\": \"Status\",}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events." } },
            { no: 21, name: "subscription_add_ons_state", kind: "map", localName: "subscription_add_ons_state", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Cloud DVR 1000\": \"Status\",\"Family Share\": \"Status\",}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events." } },
            { no: 22, name: "subscription_add_ons_trial", kind: "map", localName: "subscription_add_ons_trial", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Cloud DVR 1000\": \"Active\",\"Family Share\": \"Canceled\",}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events." } },
            { no: 23, name: "subscription_base_billing_status", kind: "map", localName: "subscription_base_billing_status", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Fubo Base\": \"Status\"}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events." } },
            { no: 24, name: "subscription_base_state", kind: "map", localName: "subscription_base_state", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Fubo Base\": \"Status\"}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events/" } },
            { no: 25, name: "subscription_base_trial", kind: "map", localName: "subscription_base_trial", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "{\"Fubo Base\": \"Active\"}", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Subscription Events." } },
            { no: 26, name: "subscription_date", kind: "scalar", localName: "subscription_date", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2046-01-01", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Date when the user registered." } },
            { no: 27, name: "subscription_device_category", kind: "enum", localName: "subscription_device_category", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue", DeviceCategory_DeviceCategoryValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "smart_tv", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device used by the user to register." } },
            { no: 28, name: "subscription_os", kind: "scalar", localName: "subscription_os", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "android", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "OS used by the user to register." } },
            { no: 29, name: "subscription_referrer", kind: "scalar", localName: "subscription_referrer", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Referer which leads to the registration, referrer url. used on affiliate links." } },
            { no: 30, name: "subscription_utm_medium", kind: "scalar", localName: "subscription_utm_medium", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "sms, email, link, etc.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Medium which leads to the registration." } },
            { no: 31, name: "subscription_utm_source", kind: "scalar", localName: "subscription_utm_source", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "site sending traffic, i.e. google, facebook, bing, etc.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Source which leads to the registration." } },
            { no: 32, name: "user_id", kind: "scalar", localName: "user_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1234567890", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "User ID." } },
            { no: 33, name: "hashed_email", kind: "scalar", localName: "hashed_email", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Hashed email, originally from platform backend." } }
        ]);
    }
    create(value?: PartialMessage<UserProperties>): UserProperties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.products = [];
        message.subscription_add_ons_billing_status = {};
        message.subscription_add_ons_state = {};
        message.subscription_add_ons_trial = {};
        message.subscription_base_billing_status = {};
        message.subscription_base_state = {};
        message.subscription_base_trial = {};
        if (value !== undefined)
            reflectionMergePartial<UserProperties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserProperties): UserProperties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string anonymous_id */ 1:
                    message.anonymous_id = reader.string();
                    break;
                case /* optional int32 favorites_channels_count */ 2:
                    message.favorites_channels_count = reader.int32();
                    break;
                case /* optional int32 follow_series_count */ 3:
                    message.follow_series_count = reader.int32();
                    break;
                case /* optional int32 follow_teams_count */ 4:
                    message.follow_teams_count = reader.int32();
                    break;
                case /* optional string home_country_code */ 5:
                    message.home_country_code = reader.string();
                    break;
                case /* optional string home_dma */ 6:
                    message.home_dma = reader.string();
                    break;
                case /* optional string home_zip_code */ 7:
                    message.home_zip_code = reader.string();
                    break;
                case /* optional bool internal_user */ 8:
                    message.internal_user = reader.bool();
                    break;
                case /* optional string language */ 9:
                    message.language = reader.string();
                    break;
                case /* optional string market */ 10:
                    message.market = reader.string();
                    break;
                case /* optional int32 my_stuff_movies_count */ 11:
                    message.my_stuff_movies_count = reader.int32();
                    break;
                case /* optional int32 my_stuff_series_count */ 12:
                    message.my_stuff_series_count = reader.int32();
                    break;
                case /* repeated string products */ 13:
                    message.products.push(reader.string());
                    break;
                case /* optional int32 profile_count */ 14:
                    message.profile_count = reader.int32();
                    break;
                case /* optional string profile_id */ 15:
                    message.profile_id = reader.string();
                    break;
                case /* optional double record_hours_allowed */ 16:
                    message.record_hours_allowed = reader.double();
                    break;
                case /* optional double record_hours_used */ 17:
                    message.record_hours_used = reader.double();
                    break;
                case /* optional string segment_datamkt */ 18:
                    message.segment_datamkt = reader.string();
                    break;
                case /* optional string segment_rfm28 */ 19:
                    message.segment_rfm28 = reader.string();
                    break;
                case /* map<string, string> subscription_add_ons_billing_status */ 20:
                    this.binaryReadMap20(message.subscription_add_ons_billing_status, reader, options);
                    break;
                case /* map<string, string> subscription_add_ons_state */ 21:
                    this.binaryReadMap21(message.subscription_add_ons_state, reader, options);
                    break;
                case /* map<string, string> subscription_add_ons_trial */ 22:
                    this.binaryReadMap22(message.subscription_add_ons_trial, reader, options);
                    break;
                case /* map<string, string> subscription_base_billing_status */ 23:
                    this.binaryReadMap23(message.subscription_base_billing_status, reader, options);
                    break;
                case /* map<string, string> subscription_base_state */ 24:
                    this.binaryReadMap24(message.subscription_base_state, reader, options);
                    break;
                case /* map<string, string> subscription_base_trial */ 25:
                    this.binaryReadMap25(message.subscription_base_trial, reader, options);
                    break;
                case /* optional string subscription_date */ 26:
                    message.subscription_date = reader.string();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue subscription_device_category */ 27:
                    message.subscription_device_category = reader.int32();
                    break;
                case /* optional string subscription_os */ 28:
                    message.subscription_os = reader.string();
                    break;
                case /* optional string subscription_referrer */ 29:
                    message.subscription_referrer = reader.string();
                    break;
                case /* optional string subscription_utm_medium */ 30:
                    message.subscription_utm_medium = reader.string();
                    break;
                case /* optional string subscription_utm_source */ 31:
                    message.subscription_utm_source = reader.string();
                    break;
                case /* optional string user_id */ 32:
                    message.user_id = reader.string();
                    break;
                case /* optional string hashed_email */ 33:
                    message.hashed_email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap20(map: UserProperties["subscription_add_ons_billing_status"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_add_ons_billing_status"] | undefined, val: UserProperties["subscription_add_ons_billing_status"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_add_ons_billing_status");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap21(map: UserProperties["subscription_add_ons_state"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_add_ons_state"] | undefined, val: UserProperties["subscription_add_ons_state"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_add_ons_state");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap22(map: UserProperties["subscription_add_ons_trial"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_add_ons_trial"] | undefined, val: UserProperties["subscription_add_ons_trial"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_add_ons_trial");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap23(map: UserProperties["subscription_base_billing_status"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_base_billing_status"] | undefined, val: UserProperties["subscription_base_billing_status"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_base_billing_status");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap24(map: UserProperties["subscription_base_state"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_base_state"] | undefined, val: UserProperties["subscription_base_state"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_base_state");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap25(map: UserProperties["subscription_base_trial"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserProperties["subscription_base_trial"] | undefined, val: UserProperties["subscription_base_trial"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field fubo.tv.proto.common.v3.generic.UserProperties.subscription_base_trial");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: UserProperties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string anonymous_id = 1; */
        if (message.anonymous_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.anonymous_id);
        /* optional int32 favorites_channels_count = 2; */
        if (message.favorites_channels_count !== undefined)
            writer.tag(2, WireType.Varint).int32(message.favorites_channels_count);
        /* optional int32 follow_series_count = 3; */
        if (message.follow_series_count !== undefined)
            writer.tag(3, WireType.Varint).int32(message.follow_series_count);
        /* optional int32 follow_teams_count = 4; */
        if (message.follow_teams_count !== undefined)
            writer.tag(4, WireType.Varint).int32(message.follow_teams_count);
        /* optional string home_country_code = 5; */
        if (message.home_country_code !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.home_country_code);
        /* optional string home_dma = 6; */
        if (message.home_dma !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.home_dma);
        /* optional string home_zip_code = 7; */
        if (message.home_zip_code !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.home_zip_code);
        /* optional bool internal_user = 8; */
        if (message.internal_user !== undefined)
            writer.tag(8, WireType.Varint).bool(message.internal_user);
        /* optional string language = 9; */
        if (message.language !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.language);
        /* optional string market = 10; */
        if (message.market !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.market);
        /* optional int32 my_stuff_movies_count = 11; */
        if (message.my_stuff_movies_count !== undefined)
            writer.tag(11, WireType.Varint).int32(message.my_stuff_movies_count);
        /* optional int32 my_stuff_series_count = 12; */
        if (message.my_stuff_series_count !== undefined)
            writer.tag(12, WireType.Varint).int32(message.my_stuff_series_count);
        /* repeated string products = 13; */
        for (let i = 0; i < message.products.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.products[i]);
        /* optional int32 profile_count = 14; */
        if (message.profile_count !== undefined)
            writer.tag(14, WireType.Varint).int32(message.profile_count);
        /* optional string profile_id = 15; */
        if (message.profile_id !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.profile_id);
        /* optional double record_hours_allowed = 16; */
        if (message.record_hours_allowed !== undefined)
            writer.tag(16, WireType.Bit64).double(message.record_hours_allowed);
        /* optional double record_hours_used = 17; */
        if (message.record_hours_used !== undefined)
            writer.tag(17, WireType.Bit64).double(message.record_hours_used);
        /* optional string segment_datamkt = 18; */
        if (message.segment_datamkt !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.segment_datamkt);
        /* optional string segment_rfm28 = 19; */
        if (message.segment_rfm28 !== undefined)
            writer.tag(19, WireType.LengthDelimited).string(message.segment_rfm28);
        /* map<string, string> subscription_add_ons_billing_status = 20; */
        for (let k of globalThis.Object.keys(message.subscription_add_ons_billing_status))
            writer.tag(20, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_add_ons_billing_status[k]).join();
        /* map<string, string> subscription_add_ons_state = 21; */
        for (let k of globalThis.Object.keys(message.subscription_add_ons_state))
            writer.tag(21, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_add_ons_state[k]).join();
        /* map<string, string> subscription_add_ons_trial = 22; */
        for (let k of globalThis.Object.keys(message.subscription_add_ons_trial))
            writer.tag(22, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_add_ons_trial[k]).join();
        /* map<string, string> subscription_base_billing_status = 23; */
        for (let k of globalThis.Object.keys(message.subscription_base_billing_status))
            writer.tag(23, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_base_billing_status[k]).join();
        /* map<string, string> subscription_base_state = 24; */
        for (let k of globalThis.Object.keys(message.subscription_base_state))
            writer.tag(24, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_base_state[k]).join();
        /* map<string, string> subscription_base_trial = 25; */
        for (let k of globalThis.Object.keys(message.subscription_base_trial))
            writer.tag(25, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.subscription_base_trial[k]).join();
        /* optional string subscription_date = 26; */
        if (message.subscription_date !== undefined)
            writer.tag(26, WireType.LengthDelimited).string(message.subscription_date);
        /* optional fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue subscription_device_category = 27; */
        if (message.subscription_device_category !== undefined)
            writer.tag(27, WireType.Varint).int32(message.subscription_device_category);
        /* optional string subscription_os = 28; */
        if (message.subscription_os !== undefined)
            writer.tag(28, WireType.LengthDelimited).string(message.subscription_os);
        /* optional string subscription_referrer = 29; */
        if (message.subscription_referrer !== undefined)
            writer.tag(29, WireType.LengthDelimited).string(message.subscription_referrer);
        /* optional string subscription_utm_medium = 30; */
        if (message.subscription_utm_medium !== undefined)
            writer.tag(30, WireType.LengthDelimited).string(message.subscription_utm_medium);
        /* optional string subscription_utm_source = 31; */
        if (message.subscription_utm_source !== undefined)
            writer.tag(31, WireType.LengthDelimited).string(message.subscription_utm_source);
        /* optional string user_id = 32; */
        if (message.user_id !== undefined)
            writer.tag(32, WireType.LengthDelimited).string(message.user_id);
        /* optional string hashed_email = 33; */
        if (message.hashed_email !== undefined)
            writer.tag(33, WireType.LengthDelimited).string(message.hashed_email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.UserProperties
 */
export const UserProperties = new UserProperties$Type();
